import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './marketing.css';

/**
 * Shared sticky header for public marketing pages (Pricing, Features, Contact).
 * Visually identical to the nav inside /public/site/index.html — translucent
 * green over hero, switches to white on scroll.
 *
 * `solid` prop forces the white/scrolled appearance (for pages without a dark
 * hero — e.g. Pricing opens on cream, so we lock it solid from load).
 */
export default function MarketingHeader({ solid = false }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [scrolled, setScrolled] = useState(solid);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (solid) { setScrolled(true); return; }
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [solid]);

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <nav
      className={`marketing-nav${scrolled ? ' is-scrolled' : ''}${menuOpen ? ' menu-open' : ''}`}
      data-testid="marketing-header"
    >
      <button
        type="button"
        aria-label="Ludy home"
        onClick={() => go('/')}
        className="marketing-nav-logo-btn"
        data-testid="marketing-header-logo"
      >
        <img src="/ludy-wordmark.png" alt="Ludy" className="marketing-nav-logo" />
      </button>

      <ul className="marketing-nav-links">
        <li><a href="/features" onClick={(e) => { e.preventDefault(); go('/features'); }} data-testid="marketing-header-features">Features</a></li>
        <li><a href="/pricing" onClick={(e) => { e.preventDefault(); go('/pricing'); }} data-testid="marketing-header-pricing">Pricing</a></li>
        {isAuthenticated ? (
          <li>
            <a
              href="/dashboard"
              onClick={(e) => { e.preventDefault(); go('/dashboard'); }}
              className="marketing-nav-cta"
              data-testid="marketing-header-dashboard"
            >
              Dashboard
            </a>
          </li>
        ) : (
          <>
            <li>
              <a
                href="/auth"
                onClick={(e) => { e.preventDefault(); go('/auth'); }}
                className="marketing-nav-signin"
                data-testid="marketing-header-signin"
              >
                Sign in
              </a>
            </li>
            <li>
              <a
                href="/auth"
                onClick={(e) => { e.preventDefault(); go('/auth'); }}
                className="marketing-nav-cta"
                data-testid="marketing-header-cta"
              >
                Start free
              </a>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}
